"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var AddressCard = /** @class */ (function (_super) {
    __extends(AddressCard, _super);
    function AddressCard(props) {
        var _this = _super.call(this, props) || this;
        _this.openForm = function () {
            _this.setState({
                showForm: true
            });
        };
        _this.closeForm = function () {
            _this.setState({
                showForm: false
            });
        };
        _this.buildForm = function () {
            return _this.state.showForm ? React.createElement(Snippets.AddressForm, { address: _this.state.defaultAddress, closeForm: _this.closeForm }) : null;
        };
        _this.state = {
            showForm: false,
            defaultAddress: props.address
        };
        return _this;
    }
    AddressCard.prototype.render = function () {
        var _this = this;
        var _a = this.props, address = _a.address, deleteForm = _a.deleteForm;
        var isDefault = !!(address && address.default);
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "flex flex-col flex-1 relative min-w-full text-grey-dark" },
                React.createElement(Snippets.AddressDetails, { className: "flex-1", address: address }),
                address && (React.createElement("div", { className: "mt-2" },
                    React.createElement("div", { className: "flex flex-row align-middle ml-0 w-1/2" },
                        React.createElement("div", { className: "block align-middle" },
                            React.createElement(Snippets.Button, { style: "text", onClick: function () { return _this.openForm(); } },
                                React.createElement("span", null,
                                    React.createElement(Snippets.Svg, { name: "edit", height: 16, width: 16, className: "inline-block align-middle pr-0-2" })),
                                React.createElement("span", { className: "ml-0-4 text-base font-bold uppercase inline-block align-middle" }, "edit"))),
                        deleteForm && (React.createElement("div", { className: "block align-middle ml-4-8" },
                            React.createElement(next_components_1.ShopifyNext.Components.Forms, { data: __assign(__assign({}, deleteForm), { form: __assign(__assign({}, deleteForm.form), { action: deleteForm.form.action + address.id }) }) },
                                React.createElement("input", { type: "hidden", name: "return_to", value: "/" }),
                                React.createElement(Snippets.Button, { style: "text", type: "submit", onClick: function () { }, disabled: isDefault },
                                    React.createElement("span", null,
                                        React.createElement(Snippets.Svg, { name: "close", height: 14, className: "ml-0-4 inline-block align-middle pr-0-2 text-red" })),
                                    React.createElement("span", { className: "text-base text-red font-bold inline-block align-middle uppercase mt-0-2" }, "remove"))))))))),
            React.createElement("section", { className: "fixed flex md:items-center justify-center pin z-100 overflow-auto p-1-6 " + (this.state.showForm ? "transition visible" : "transition-fast invisible") },
                React.createElement("div", { className: "absolute pin bg-navy-dark " + (this.state.showForm ? "transition opacity-60" : "transition-fast opacity-0"), onClick: function () { return _this.closeForm(); } }),
                React.createElement("div", { className: "relative w-full max-w-43-6 " + (this.state.showForm
                        ? "transition transition-delay translate-y:0 visible opacity-100"
                        : "transition-fast transition-delay-none translate-y:20x invisible opacity-0") }, this.buildForm()))));
    };
    return AddressCard;
}(React.PureComponent));
exports.AddressCard = AddressCard;
